import { Link, useRouteError } from 'react-router-dom';
import routes from '@/routes/index';
import { useTranslation } from 'react-i18next';
import classes from './style.module.css';

const NoMatch = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  const {
    statusText,
    message,
    status,
  } = error || {};

  const content = statusText || message;
  const errorStatus = (status === 404) ? '404' : '500';
  const errorMessage = (status === 404) ? t('pages.error.notFound') : t('pages.error.error');

  return (
    <section className="content">
      <div className={classes.main}>
        <div className={classes.info}>
          <h1>{errorStatus}</h1>
          <h2>{t('pages.error.title')}</h2>
          <p>{errorMessage}</p>
          <p className={classes.hidden}>{content}</p>
          <Link to={routes.main.path}>{t('pages.error.link.title')}</Link>
        </div>
      </div>
    </section>
  );
};

export default NoMatch;
